import type {
  Currency,
  CurrencyCode,
} from "@aprao/common/src/shapes/Currency.js";
import type {
  LengthUnit,
  LengthUnitCode,
} from "@aprao/common/src/shapes/LengthUnit.js";
import { expectNotNull } from "option-t/nullable";
import { createContext, use } from "react";

import { getCurrency } from "../i18n/getCurrency.js";
import { lengthUnitsByCodes } from "../i18n/lengthUnits.js";

interface NumberUnits {
  currency: Currency;
  lengthUnit: LengthUnit;
}

export const createNumberUnits = (
  locale: Intl.LocalesArgument,
  currencyCode: CurrencyCode,
  lengthCode: LengthUnitCode,
): NumberUnits => ({
  currency: getCurrency(locale, currencyCode),
  lengthUnit: lengthUnitsByCodes[lengthCode],
});

export const NumberUnitsContext = createContext<NumberUnits | null>(null);

export const useNumberUnits = () =>
  expectNotNull(
    use(NumberUnitsContext),
    "NumberUnitsContext should be initialised",
  );
